import clsx from 'clsx'
import { ComponentProps } from 'react'

export function PageFormHeader({ className, ...props }: ComponentProps<'div'>) {
  return <div className={clsx(className, 'mt-8')} {...props} />
}

export function PageFormBody({ className, ...props }: ComponentProps<'div'>) {
  return <div className={clsx(className, 'mt-6')} {...props} />
}

export function PageFormFooter({ className, ...props }: ComponentProps<'div'>) {
  return <div className={clsx(className, 'mt-8')} {...props} />
}

export function PageForm({ className, ...props }: ComponentProps<'form'>) {
  return <form className={clsx(className, 'mx-auto max-w-prose')} {...props} />
}
